<script setup lang="ts">
import TopBar from "@/components/TopBar";
import MobileMenu from "@/components/MobileMenu";
import { onMounted, ref, watch } from "vue";
import {useRoute} from "vue-router";
import resolveConfig from "tailwindcss/resolveConfig";
// @ts-ignore
import tailwindConfig from "../../tailwind.config.js";
import MainMenu from "@/components/MainMenu/MainMenu.vue";
const twConfig = resolveConfig(tailwindConfig);
const style = ref("width:100%");

const position = ref("side");
const currlay = ref("rubick");
const route = useRoute();
const isEagente = ref(false);
const isMainPage = ref(false);

  watch(
    () => route.path,
    (newValue) => {
      checkForEagente()
    }
  );

function checkForEagente() {
  // check to show dashboard
  if(route.path == "/management") {
    isMainPage.value = true;
  } else {
    isMainPage.value = false;
  }



  if(route.path.includes("eagente")) {
    isEagente.value = true;
    const targetOrigin = window.location.origin;
    window.postMessage("forceRouter", targetOrigin);
    /*
    if(document.getElementById("sub-platform") != null) {
      //  @ts-ignore
    document.getElementById("sub-platform").style.height = "";
    }*/
  } else {
    isEagente.value = false;
    /*
    if(document.getElementById("sub-platform") != null) {
      //  @ts-ignore
    document.getElementById("sub-platform").style.height = "72px";
    }*/
  }
}

// TODO check if needed
function checkForSubContainer() {
  if (document.getElementById("sub_app_1") == null) {
    let newDiv = document.createElement("div");
    newDiv.setAttribute("id", "sub_app_1");
    // @ts-ignore
    document.getElementById("mainContainer").appendChild(newDiv);
  }
}

onMounted(() => {
  window.addEventListener("updateTheme", setTheme);

  checkForSubContainer();
  observeWidth();
  setTheme();
  checkForEagente();
});

function setTheme() {
  const themeFromStorage = localStorage.getItem("theme");

  if (!themeFromStorage) {
    currlay.value = "rubick";
    position.value = "side";
    return;
  }

  const theme = JSON.parse(themeFromStorage);
  currlay.value = theme.layout;
  position.value = theme.menuPosition;
}

function observeWidth() {
  const filterElement = document.getElementById("filter-container");

  const resizeObserver = new ResizeObserver(function (entry) {
    const width = entry[0].borderBoxSize[0].inlineSize;
    let mdBreakpoint = twConfig.theme.screens.md;
    mdBreakpoint = Number(mdBreakpoint.substring(0, mdBreakpoint.length - 2));

    if (width === 0 || (width !== 0 && window.innerWidth <= mdBreakpoint)) {
      style.value = `width:100%;`;
    }

    if (width !== 0 && window.innerWidth > mdBreakpoint) {
      style.value = `width:calc(100% - ${width}px);`;
    }
  });

  if (!filterElement) {
    return;
  }

  resizeObserver.observe(filterElement);
}
</script>

<template>
  <MobileMenu v-if ="!isEagente" />
  <div v-if ="!isEagente"
    :class="[
      {
        'p-4 sm:px-8 sm:py-': currlay === 'rubick',
      },
      {
        'bg-primary md:bg-slate-200 dark:bg-transparent': currlay === 'enigma',
      },
      {
        'sm:px-8 p-4 icewall-bg': currlay === 'icewall',
        'pl-4': currlay === 'tinker',
      },
    ]"
  >
    <TopBar
      v-if="(currlay === 'enigma' || currlay === 'icewall') && !isEagente"
      :layout="currlay"
    />
    <MainMenu
      v-if="(position === 'top') && !isEagente"
      :position="'top'"
      :layout="currlay"
    ></MainMenu> 
    <div
      :class="[
        {
          'flex mt-[4.7rem] md:mt-0':
            currlay !== 'icewall' && currlay !== 'enigma',
        },
        {
          'flex relative mt-5 sm:mt-10': currlay === 'icewall',
          'before:content-[\'\'] before:top-[5px] before:w-[95%] before:z-[-1] before:rounded-[1.3rem] before:bg-white/10 before:h-full before:-mt-4 before:absolute before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/50':
            currlay === 'icewall',
        },
      ]"
    >
      <div
        :class="[
          'flex w-full',
          {
            ' rounded-[1.3rem] bg-primary dark:bg-darkmode-400':
              currlay === 'icewall',
            'before:block before:absolute before:inset-0 before:bg-black/[0.15] before:dark:bg-transparent before:rounded-[1.3rem] before:z-[-1]':
              currlay === 'icewall',
            'animate-[0.4s_ease-in-out_0.2s_intro-wrapper] animate-fill-mode-forwards translate-y-[5px]':
              currlay === 'icewall',
            'md:pt-[86px]': position === 'top' && currlay === 'icewall',
          },
        ]"
      >
        <MainMenu
          :position="position"
          v-if="(position === 'side' || position === 'simple') && !isEagente"
          :layout="currlay"
        ></MainMenu>
        <!-- BEGIN: Content -->
        <div
          id="mainContainer"
          :class="[
            'pt-4 px-4 pb-10 min-h-screen',
            {
              'rounded-[30px] min-w-0 flex-1 bg-slate-100 dark:bg-darkmode-700 md:px-[22px] max-w-full md:max-w-auto ':
                currlay === 'rubick',
              'before:content-[\'\'] before:w-full before:h-px before:block':
                currlay === 'rubick',
            },
            {
              'max-w-full md:max-w-none rounded-t-[30px] md:px-[22px] min-w-0 bg-slate-100 flex-1 md:pt-20 mt-5 md:mt-1 relative dark:bg-darkmode-700':
                currlay === 'enigma',
              'before:content-[\'\'] before:w-full before:h-px before:block':
                currlay === 'enigma',
            },
            {
              'md:px-[22px] max-w-full md:max-w-auto rounded-[1.3rem] flex-1 min-w-0 shadow-sm bg-slate-100 dark:bg-darkmode-700 ':
                currlay === 'icewall',
              'before:w-full before:h-px before:block': currlay === 'icewall',
            },
            {
              'rounded-tl-[30px] md:rounded-[35px/50px_0px_0px_0px] min-w-0  md:max-w-none bg-slate-100 flex-1 md:px-6 relative md:ml-4 dark:bg-darkmode-700':
                currlay === 'tinker',
              'before:content-[\'\'] before:w-full before:h-px before:block':
                currlay === 'tinker',
              'after:content-[\'\'] after:z-[-1] after:rounded-[40px_0px_0px_0px] after:w-full after:inset-y-0 after:absolute after:left-0 after:bg-white/10 after:mt-8 after:-ml-4 after:dark:bg-darkmode-400/50':
                currlay === 'tinker',
            },
          ]"
        >
          <TopBar
            v-if="(currlay === 'rubick' || currlay === 'tinker') && !isEagente"
            :layout="currlay"
          />
          <!---<RouterView />-->
          <DashboardOverview1 v-if="isMainPage"></DashboardOverview1>
          <div
            id="subapp-viewport-toolbar"
            class="subApp flex sm:justify-between xl:flex-nowrap items-center"
          >
            <div class="flex flex-col sm:flex-row w-full gap-4 pt-4">
              <div class="" id="search-container"></div>
              <div class="flex flex-row flex-wrap gap-4 justify-between w-full">
                <div class="flex flex-row flex-wrap gap-4">
                  <div id="sort-container"></div>
                  <div id="column-container"></div>
                  <div id="filter-button"></div>
                </div>
                <div class="flex flex-row flex-wrap gap-4">
                <div id="button-container"></div>
                <div id="export-container"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row w-full mt-4">
            <div id="filter-container"></div>
            <div id="datalist-container" :style="style"></div>
          </div>
          <div id="sub_app_1" class="subApp"></div>
          <div id="uploader-container" class="subApp"></div>
          <div id="subapp-viewport-pagination" class="subApp"></div>
          <div id="multipart-form-container"></div>
          <div id="process-container"></div>
          <div id="workflow-container"></div>
        </div>
        <!-- END: Content -->
      </div>
    </div>
  </div>
  <div v-else>
    <div id="sub_app_1" class="subApp"></div>
  </div>
</template>
